// extracted by mini-css-extract-plugin
export default {"message_highlight":"IChat_message_highlight__+haG9","highlight":"IChat_highlight__l1wMH","smooth-scroll-container":"IChat_smooth-scroll-container__QW0+9"};